import React, {useContext} from 'react';
import {FormattedMessage} from "react-intl";

import SidebarHeadingTitle from "../SidebarHeadingTitle";
import RetailerMenu from "./components/RetailerMenu";

import {APPLICATIONS} from "utils/Applications";
import {greyishBlue100} from "assets/jss/main";

import {SidebarContext} from "../../../../SidebarContext";
import {Divider} from "@mui/material";

function Retailers(props) {
    const {currentMember, selectedRetailer, selectedApplication, isUserAdmin} = useContext(SidebarContext);

    if (selectedApplication !== APPLICATIONS.MARKETPLACE || (!isUserAdmin && !currentMember?.retailers) || !selectedRetailer) {
        return null;
    }

    function getFirstFourRetailers(retailers) {
        if (!selectedRetailer) {
            return [];
        }

        // exclude selected retailer
        retailers = retailers.filter((retailer) => retailer.id !== selectedRetailer.id)

        return retailers.slice(0, 4);
    }

    return (
        <div>
            <Divider sx={{borderColor: greyishBlue100}}/>
            <div style={{padding: '12px'}}>
                <SidebarHeadingTitle>
                    <FormattedMessage id='sidebar.retailers.title' />
                </SidebarHeadingTitle>
                <RetailerMenu retailer={selectedRetailer} />
                {currentMember?.retailers && getFirstFourRetailers(currentMember?.retailers).map((retailer) => (
                    <RetailerMenu key={retailer.id} retailer={retailer} />
                ))}
            </div>
            <Divider sx={{borderColor: greyishBlue100}}/>
        </div>
    );
}

export default Retailers;
